export const onLanguageChange = (isTamil) => ({
  type: "ACTION_CHANGE_LANGUAGE",
  isTamil,
});
